package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class MindMapQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    title: String,
    color: String?,
    skill_id: String?,
    objective_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-675_724_455, arrayOf("mind_map"), driver, "MindMap.sq", "selectAll",
      "SELECT mind_map.id, mind_map.title, mind_map.color, mind_map.skill_id, mind_map.objective_id, mind_map.order_index, mind_map.created_at, mind_map.updated_at, mind_map.is_deleted, mind_map.deleted_at, mind_map.synced_at FROM mind_map WHERE is_deleted = 0 ORDER BY updated_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectAll(): Query<Mind_map> = selectAll { id, title, color, skill_id, objective_id,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map(
      id,
      title,
      color,
      skill_id,
      objective_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    title: String,
    color: String?,
    skill_id: String?,
    objective_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectById(id: String): Query<Mind_map> = selectById(id) { id_, title, color, skill_id,
      objective_id, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map(
      id_,
      title,
      color,
      skill_id,
      objective_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectBySkill(skill_id: String?, mapper: (
    id: String,
    title: String,
    color: String?,
    skill_id: String?,
    objective_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectBySkillQuery(skill_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectBySkill(skill_id: String?): Query<Mind_map> = selectBySkill(skill_id) { id,
      title, color, skill_id_, objective_id, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Mind_map(
      id,
      title,
      color,
      skill_id_,
      objective_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByObjective(objective_id: String?, mapper: (
    id: String,
    title: String,
    color: String?,
    skill_id: String?,
    objective_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByObjectiveQuery(objective_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByObjective(objective_id: String?): Query<Mind_map> =
      selectByObjective(objective_id) { id, title, color, skill_id, objective_id_, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map(
      id,
      title,
      color,
      skill_id,
      objective_id_,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    title: String,
    color: String?,
    skill_id: String?,
    objective_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-828_448_886, arrayOf("mind_map"), driver, "MindMap.sq", "selectDirty",
      "SELECT mind_map.id, mind_map.title, mind_map.color, mind_map.skill_id, mind_map.objective_id, mind_map.order_index, mind_map.created_at, mind_map.updated_at, mind_map.is_deleted, mind_map.deleted_at, mind_map.synced_at FROM mind_map WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectDirty(): Query<Mind_map> = selectDirty { id, title, color, skill_id,
      objective_id, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Mind_map(
      id,
      title,
      color,
      skill_id,
      objective_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    title: String,
    color: String?,
    skill_id: String?,
    objective_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Mind_map> = selectByIdAnyState(id) { id_, title,
      color, skill_id, objective_id, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Mind_map(
      id_,
      title,
      color,
      skill_id,
      objective_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    title: String,
    color: String?,
    skill_id: String?,
    objective_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(2_025_609_957, """
        |INSERT INTO mind_map(id, title, color, skill_id, objective_id, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindString(0, id)
          bindString(1, title)
          bindString(2, color)
          bindString(3, skill_id)
          bindString(4, objective_id)
          bindLong(5, order_index)
          bindLong(6, created_at)
          bindLong(7, updated_at)
        }
    notifyQueries(2_025_609_957) { emit ->
      emit("mind_map")
    }
  }

  public fun update(
    title: String,
    color: String?,
    skill_id: String?,
    objective_id: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_924_411_147, """
        |UPDATE mind_map
        |SET title = ?, color = ?, skill_id = ?, objective_id = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 7) {
          bindString(0, title)
          bindString(1, color)
          bindString(2, skill_id)
          bindString(3, objective_id)
          bindLong(4, order_index)
          bindLong(5, updated_at)
          bindString(6, id)
        }
    notifyQueries(-1_924_411_147) { emit ->
      emit("mind_map")
    }
  }

  public fun setTitle(
    title: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_854_283_842, """UPDATE mind_map SET title = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindString(0, title)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_854_283_842) { emit ->
      emit("mind_map")
    }
  }

  public fun setColor(
    color: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_838_755_149, """UPDATE mind_map SET color = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindString(0, color)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_838_755_149) { emit ->
      emit("mind_map")
    }
  }

  public fun setAttachments(
    skill_id: String?,
    objective_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_507_446_246,
        """UPDATE mind_map SET skill_id = ?, objective_id = ?, updated_at = ? WHERE id = ?""", 4) {
          bindString(0, skill_id)
          bindString(1, objective_id)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(-1_507_446_246) { emit ->
      emit("mind_map")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_588_314_273,
        """UPDATE mind_map SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_588_314_273) { emit ->
      emit("mind_map")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_804_746_722,
        """UPDATE mind_map SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""", 2)
        {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_804_746_722) { emit ->
      emit("mind_map")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(1_408_252_066, """DELETE FROM mind_map WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(1_408_252_066) { emit ->
      emit("mind_map")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_503_759_405,
        """UPDATE mind_map SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_503_759_405) { emit ->
      emit("mind_map")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(527_419_674,
        """SELECT mind_map.id, mind_map.title, mind_map.color, mind_map.skill_id, mind_map.objective_id, mind_map.order_index, mind_map.created_at, mind_map.updated_at, mind_map.is_deleted, mind_map.deleted_at, mind_map.synced_at FROM mind_map WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "MindMap.sq:selectById"
  }

  private inner class SelectBySkillQuery<out T : Any>(
    public val skill_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT mind_map.id, mind_map.title, mind_map.color, mind_map.skill_id, mind_map.objective_id, mind_map.order_index, mind_map.created_at, mind_map.updated_at, mind_map.is_deleted, mind_map.deleted_at, mind_map.synced_at FROM mind_map WHERE skill_id ${ if (skill_id == null) "IS" else "=" } ? AND is_deleted = 0 ORDER BY updated_at DESC""",
        mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "MindMap.sq:selectBySkill"
  }

  private inner class SelectByObjectiveQuery<out T : Any>(
    public val objective_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT mind_map.id, mind_map.title, mind_map.color, mind_map.skill_id, mind_map.objective_id, mind_map.order_index, mind_map.created_at, mind_map.updated_at, mind_map.is_deleted, mind_map.deleted_at, mind_map.synced_at FROM mind_map WHERE objective_id ${ if (objective_id == null) "IS" else "=" } ? AND is_deleted = 0 ORDER BY updated_at DESC""",
        mapper, 1) {
      bindString(0, objective_id)
    }

    override fun toString(): String = "MindMap.sq:selectByObjective"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("mind_map", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("mind_map", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-119_135_937,
        """SELECT mind_map.id, mind_map.title, mind_map.color, mind_map.skill_id, mind_map.objective_id, mind_map.order_index, mind_map.created_at, mind_map.updated_at, mind_map.is_deleted, mind_map.deleted_at, mind_map.synced_at FROM mind_map WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "MindMap.sq:selectByIdAnyState"
  }
}
